import React from 'react';
import { useSession } from '../../contexts/SessionContext';
import { Alert } from '../../components/ui';

/**
 * Sits below the top bar on desktop and above the tab bar on mobile, so it
 * never covers the navigation the user needs to act on it.
 */
const LogoutNotification = () => {
  const { showLogoutNotification } = useSession();

  if (!showLogoutNotification) return null;

  return (
    <div className="fixed inset-x-4 bottom-[calc(var(--bottom-nav-height)+env(safe-area-inset-bottom,0px)+0.75rem)] z-50 animate-slide-up sm:inset-x-auto sm:bottom-auto sm:right-4 sm:top-[calc(var(--nav-height)+1rem)] sm:max-w-sm sm:animate-slide-in-right">
      <Alert variant="error" title="Session expired" className="shadow-lg">
        You were signed out due to inactivity. Please sign in again to continue.
      </Alert>
    </div>
  );
};

export default LogoutNotification;
